import { cashbackApi } from '@api/index';
import { useQuery } from '@hooks/useQuery';
import { QUERIES } from '@query/queries';

export const useCashbackRatesQuery = () => {
  return useQuery([QUERIES.CASHBACK_RATES], () => cashbackApi.getRates());
};
